import ConcernsTabContainer from './ConcernsTabContainer';

export default ConcernsTabContainer;
